import React from "react";
import "./QuestionPage.css";
import us from "../assets/us.png";
import flowerGiving from "../assets/flowerGiving.png";
import cover from "../assets/cover.png";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router";
import MobileScaleWrapper from "../MobileScaleWrapper";

const QuestionPage = () => {
  const [noHovered, setNoHovered] = React.useState(false);
  const [yesHovered, setYesHovered] = React.useState(false);

  const navigate = useNavigate();
  const handleClick = (isYes) => {
    if (isYes) {
      navigate("/archives/2025/sheSaidYes");
    } else {
      navigate("/archives/2025/sheSaidNo");
    }
  };

  return (
    <>
      <button
        className="back-btn-mobile"
        onClick={() => navigate("/")}
      >
        ← other years
      </button>
      <MobileScaleWrapper gradientTop="#c9a0a0" gradientBottom="#e8b4b8">
        <div
          className="container"
          style={{
            backgroundColor: noHovered ? "black" : yesHovered ? "#FFB8B9" : "",
          }}
        >
          <button
            className="back-btn"
            onClick={() => navigate("/")}
            style={{
              color: noHovered
                ? "rgba(255,255,255,0.4)"
                : "rgba(81,29,30,0.45)",
            }}
          >
            ← other years
          </button>
        <div className="row one">
          <div className="col one">
            {!noHovered && <img className="cover" src={cover} alt="cover" />}
          </div>
          <div className="col two">
            <div className="title">Will You Be My Valentine?</div>

            <div className="btn-group">
              <button
                className="btn"
                onMouseEnter={() => setNoHovered(true)}
                onMouseLeave={() => setNoHovered(false)}
                onClick={() => handleClick(false)}
              >
                No
              </button>
              <button
                className="btn"
                onMouseEnter={() => setYesHovered(true)}
                onMouseLeave={() => setYesHovered(false)}
                onClick={() => handleClick(true)}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
        <AnimatePresence>
          {noHovered ? (
            <div className="row two">
              <div className="col five">
                <div className="no"></div>
              </div>
            </div>
          ) : (
            <motion.div
              className="row two"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1 }}
            >
              <div className="col three"></div>
              <div className="col four">
                {yesHovered && (
                  <motion.div
                    className="fuzzy-heart"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 1 }}
                  />
                )}
                {yesHovered && <img className="us" src={us} alt="us" />}
                {!noHovered && !yesHovered && (
                  <img
                    className="flower-giving"
                    src={flowerGiving}
                    alt="flower-giving"
                  />
                )}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      </MobileScaleWrapper>
    </>
  );
};

export default QuestionPage;
